import styled from 'styled-components';
import { tradingMessagesStyles } from 'components/molecules/trading_messages/styles';

export const Container = styled.div`
  flex: 1;
  min-height: 0;

  ${tradingMessagesStyles}

  .chat-main {
    min-width: 0;
  }

  .chat-action-btn {
    width: 32px;
    height: 32px;
    padding: 0;
  }

  .chat-action-btn .material-icons {
    font-size: 18px;
  }

  .chat-search-pane {
    width: 370px;
  }

  .chat-overview-pane {
    width: 520px;
    max-width: 45%;
  }
`;
